import { render, staticRenderFns } from "./FrontHeader.vue?vue&type=template&id=4529af8b&scoped=true&"
import script from "./FrontHeader.vue?vue&type=script&lang=js&"
export * from "./FrontHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrontHeader.vue?vue&type=style&index=0&id=4529af8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529af8b",
  null
  
)

export default component.exports